/**
 * ISO-639 code to its English name, using the browser's own language data. An unresolvable or
 * malformed tag comes back unchanged rather than blank — the code is more use to a reader than
 * nothing, and `Intl.DisplayNames` throws on a structurally invalid tag.
 */
export function languageName(code: string): string {
  if (!code) return code;

  try {
    return new Intl.DisplayNames(["en"], { type: "language" }).of(code) ?? code;
  } catch {
    return code;
  }
}
